import { render } from "./Item6.vue?vue&type=template&id=c1ea2faa&scoped=true"
import script from "./Item6.vue?vue&type=script&lang=js"
export * from "./Item6.vue?vue&type=script&lang=js"

import "./Item6.vue?vue&type=style&index=0&id=c1ea2faa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c1ea2faa"

export default script